export const abcmResult2PivotTableQuery = (portfolioId = '', rankingId = null, securityId = '', pageNumber = 0) => {
	rankingId = rankingId ? `"${rankingId}"` : null
	securityId = securityId ? `"${securityId}"` : null
	return `{
  abcmResultPaginated(
    id: ${portfolioId}
    rankingId: ${rankingId}
    securityId: ${securityId}
    page: ${pageNumber}
    size: 500
  ) {
    entries {
      id
      allocatedQuantity
      pnl
      duration
      balanceSheetContribution {
        amount
        currency
      }
      sourceAllocatedNotional {
        amount
        currency
      }
      useAllocatedNotional {
        amount
        currency
      }
      source {
        id
        allocationName
        assetTarget
        businessCode
        cusip
        duration
        balanceSheetContribution {
          amount
          currency
        }
        securityId
        isin
        ticker
        originalTradeType
        legalEntity
        ric
        bbId
        quantity
        counterParty
        assetType
        assetSubType
        exchangeRate
        price {
          amount
          currency
        }
        abcmCategoryType
        abcmCategoryName
        abcmCategoryDisplayName
        tradeType
        book
        fund
        buySellInd
        sourceSystem
        sourceSystemTradeId
        allInRate
        spread
        collateralType
        maturityType
        referenceRate
        haircut
        collateral {
          amount
          currency
        }
        notional {
          amount
          currency
        }
        baseNotional {
          currency
          amount
        }
        cash {
          amount
          currency
        }
        maturityDate
        termDate
        startDate
        endDate
        tradeDate
        hqla
        tenor
        sector
        index
        moodyRating
        snpRating
        fitchRating
        settlementStatus
        settlementDate
      }
      use {
        id
        allocationName
        assetTarget
        businessCode
        cusip
        duration
        balanceSheetContribution {
          amount
          currency
        }
        securityId
        isin
        ticker
        originalTradeType
        legalEntity
        ric
        bbId
        quantity
        counterParty
        assetType
        assetSubType
        price {
          amount
          currency
        }
        abcmCategoryType
        abcmCategoryName
        abcmCategoryDisplayName
        tradeType
        book
        fund
        buySellInd
        sourceSystem
        sourceSystemTradeId
        allInRate
        spread
        collateralType
        maturityType
        referenceRate
        haircut
        collateral {
          amount
          currency
        }
        notional {
          amount
          currency
        }
        baseNotional {
          currency
          amount
        }
        cash {
          amount
          currency
        }
        maturityDate
        termDate
        startDate
        endDate
        tradeDate
        hqla
        tenor
        sector
        index
        moodyRating
        snpRating
        fitchRating
        settlementStatus
        settlementDate
      }
    }
    totalElements
    totalPages
  }
}`
}
